import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid
} from "@material-ui/core";
import numeral from "numeral";
import { format } from "date-fns";
import styled from "styled-components";

const StyledTable = styled(Table)`
    && {
        font-family: 'Work Sans';
        display: block;
        overflow: hidden;
    }
`;

const StyledHeaderCell = styled(TableCell)`
    && {
        font-size: 16px;
        font-weight: 400;
        border-bottom: ${({ companyPrimaryColor }) => `1px dashed ${companyPrimaryColor}`};
        padding: 0 1em !important;
    }
    &&:first-child {
        font-size: 18px;
        font-weight: 500;
    }
`;

const StyledEFTableRow = styled(TableRow)`
    && {
        background-color: ${({ companyAccentColor }) => companyAccentColor}
    }
`;

const StyledEFTableCell = styled(TableCell)`
    && {
        color: #5F6368;
        font-size: 14px;
        font-weight: 400;
        width: 139px;
        padding: 0 1em !important;
    }
    &&:first-child {
        font-size: 16px;
    }
`;

const StyledNFTableRow = styled(TableRow)`
    && {
        background-color: ${({ companySecondaryColor }) => companySecondaryColor};
    }
`;

const StyledNFTableCell = styled(TableCell)`
    && {
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 400;
        width: 139px;
        padding: 0 1em !important;
    }
    &&:first-child {
        font-size: 16px;
    }
`;

const LoanTermsTable = ({
  efLoanAmount,
  efRate,
  nfRate,
  nfLoanTerm,
  nfLoanAmount,
  efMaturityDate,
  prepaymentPenalty,
  closingCosts,
  cashOut,
  refiType,
  companyPrimaryColor,
  companySecondaryColor,
  companyAccentColor
}) => {
  const maxWidth = refiType === "Refi Breakeven" ? "1063px" : "974px";
  const marginTop = refiType === "Refi Breakeven" ? "" : "1em";
  const height = refiType === "Refi Breakeven" ? "" : "calc(100% - 1px)";
  const border = refiType === "Refi Breakeven" ? "none" : `0.5px solid ${companyPrimaryColor}`;

  return (
    <Grid xs={`${refiType === "Refi Breakeven" ? 12 : 11}`} item>
      <StyledTable
        style={{
          maxWidth,
          marginTop,
          height,
          border
        }}
      >
        <TableHead>
          <TableRow>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Loan Terms</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Amount</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Rate</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Maturity</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Prepay Penalty</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Closing Costs</StyledHeaderCell>
            <StyledHeaderCell companyPrimaryColor={companyPrimaryColor}>Cash Out</StyledHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledEFTableRow companyAccentColor={companyAccentColor}>
            <StyledEFTableCell>Existing Financing</StyledEFTableCell>
            <StyledEFTableCell>{efLoanAmount ? numeral(efLoanAmount).format("$0,0") : "--"}</StyledEFTableCell>
            <StyledEFTableCell>{efRate ? numeral(efRate / 100).format("0.00%") : "--"}</StyledEFTableCell>
            <StyledEFTableCell>{efMaturityDate ? format(efMaturityDate, "M/d/yyyy") : "--"}</StyledEFTableCell>
            <StyledEFTableCell>{prepaymentPenalty ? numeral(prepaymentPenalty).format("$0,0") : "--"}</StyledEFTableCell>
            <StyledEFTableCell>--</StyledEFTableCell>
            <StyledEFTableCell>--</StyledEFTableCell>
          </StyledEFTableRow>
          <StyledNFTableRow companySecondaryColor={companySecondaryColor}>
            <StyledNFTableCell style={{ color: "#FFFFFF" }}>New Financing</StyledNFTableCell>
            <StyledNFTableCell>{numeral(nfLoanAmount).format("$0,0")}</StyledNFTableCell>
            <StyledNFTableCell>{numeral(nfRate / 100).format("0.00%")}</StyledNFTableCell>
            <StyledNFTableCell>{`${nfLoanTerm} months`}</StyledNFTableCell>
            <StyledNFTableCell>--</StyledNFTableCell>
            <StyledNFTableCell>{closingCosts ? numeral(closingCosts).format("$0,0") : "--"}</StyledNFTableCell>
            <StyledNFTableCell>{cashOut ? numeral(cashOut).format("$0,0") : "--"}</StyledNFTableCell>
          </StyledNFTableRow>
        </TableBody>
      </StyledTable>
    </Grid>
  );
};

export default LoanTermsTable;
